// @flow
import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  Box,
  Button,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import messages from '../../messages';
import TransactionRow from '../TransactionRow';

type Props = {
  fields: Array<Object>,
  addTransaction: Function,
  deleteTransaction: Function,
};

const TransactionList = ({
  fields,
  addTransaction,
  deleteTransaction,
}: Props) => (
  <>
    {fields.map((field, index) => (
      <TransactionRow
        key={field.id}
        field={`transactionCodes.${index}`}
        index={index}
        deleteTransaction={deleteTransaction}
      />
    ))}
    <Box>
      <Button variant="text" onClick={addTransaction}>
        <FormattedMessage {...messages.addTransaction} />
      </Button>
    </Box>
  </>
);

export default TransactionList;
